/**
 * TanStack Query kalitlari — BITTA joyda (docs/03-CONVENTIONS.md §7).
 *
 * Tarqoq yozilsa, `invalidateQueries` da bitta harf xato bo'lgani uchun
 * ro'yxat yangilanmay qolardi va buni faqat foydalanuvchi sezardi.
 */
export const queryKeys = {
  me: ['me'] as const,

  users: {
    all: ['users'] as const,
    list: (params: unknown) => ['users', 'list', params] as const,
    one: (id: string) => ['users', 'one', id] as const,
  },

  media: {
    all: ['media'] as const,
    list: (params: unknown) => ['media', 'list', params] as const,
    usages: (id: string) => ['media', 'usages', id] as const,
    folders: ['media', 'folders'] as const,
  },

  audit: {
    all: ['audit'] as const,
    list: (params: unknown) => ['audit', 'list', params] as const,
  },

  settings: ['settings'] as const,

  /**
   * Kontent kolleksiyalari — kalit ichida kolleksiya nomi bor.
   *
   * `queryKeys.content.all('news')` → faqat yangiliklar yangilanadi.
   * Bitta umumiy `['content']` kaliti bo'lganda sahifa saqlanganda
   * rahbariyat ro'yxati ham bekorga qayta yuklanardi.
   */
  content: {
    all: (collection: string) => ['content', collection] as const,
    list: (collection: string, params: unknown) => ['content', collection, 'list', params] as const,
    one: (collection: string, id: string) => ['content', collection, 'one', id] as const,
  },

  certificates: {
    all: ['certificates'] as const,
    list: (params: unknown) => ['certificates', 'list', params] as const,
    one: (id: string) => ['certificates', 'one', id] as const,
  },

  requests: {
    all: ['requests'] as const,
    list: (params: unknown) => ['requests', 'list', params] as const,
    one: (id: string) => ['requests', 'one', id] as const,
    stats: (period: string) => ['requests', 'stats', period] as const,
  },
} as const;
